"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _styles = require("@mui/styles");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _react = _interopRequireWildcard(require("react"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles() {
  return {};
};
var CustomNumber = /*#__PURE__*/function (_Component) {
  function CustomNumber(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomNumber);
    _this = _callSuper(this, CustomNumber, [props]);
    _this.state = {
      val: props.value
    };
    ['onChange', 'updateSurvey'].map(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomNumber, _Component);
  return (0, _createClass2["default"])(CustomNumber, [{
    key: "updateSurvey",
    value: function updateSurvey() {
      console.log('onBlur', this.state.val);
      this.props.onChange(this.state.val);
    }
  }, {
    key: "onChange",
    value: function onChange(val) {
      this.setState({
        val: val.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        value = _this$props.value,
        prefix = _this$props.prefix,
        suffix = _this$props.suffix,
        isAllowed = _this$props.isAllowed,
        className = _this$props.className,
        format = _this$props.format,
        thousandSeparator = _this$props.thousandSeparator,
        decimalSeparator = _this$props.decimalSeparator;
      return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
        customInput: _TextField["default"],
        className: className,
        value: this.state.val,
        displayType: 'input',
        prefix: prefix,
        suffix: suffix,
        isAllowed: isAllowed,
        onValueChange: function onValueChange(val) {
          return _this2.onChange(val);
        },
        onBlur: this.updateSurvey,
        format: format,
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        isNumericString: true
      });
    }
  }]);
}(_react.Component);
CustomNumber.propTypes = {
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomNumber);